import React from 'react';
import { CalendarRange } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Input } from '../ui/input';
import { isoDate } from './utils';

export const PRESETS = {
  this_month: 'This month',
  last_month: 'Last month',
  this_quarter: 'This quarter',
  last_90: 'Last 90 days',
  this_fy: 'This financial year',
  all_time: 'All time',
  custom: 'Custom range',
};

export const presetRange = (key) => {
  const t = new Date();
  const y = t.getFullYear();
  const m = t.getMonth();
  const today = isoDate(t);
  switch (key) {
    case 'last_month':
      return { from: isoDate(new Date(y, m - 1, 1)), to: isoDate(new Date(y, m, 0)) };
    case 'this_quarter':
      return { from: isoDate(new Date(y, Math.floor(m / 3) * 3, 1)), to: today };
    case 'last_90':
      return { from: isoDate(new Date(y, m, t.getDate() - 89)), to: today };
    case 'this_fy':
      return { from: isoDate(new Date(m >= 6 ? y : y - 1, 6, 1)), to: today };
    case 'all_time':
      return { from: '2023-01-01', to: today };
    default:
      return { from: isoDate(new Date(y, m, 1)), to: today };
  }
};

export const PeriodPicker = ({ preset, range, onPreset, onRange }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid="period-picker">
    <CalendarRange className="h-4 w-4 text-[#9B9590]" />
    <Select value={preset} onValueChange={onPreset}>
      <SelectTrigger className="w-[190px] border-[#E8E4DC] bg-white text-sm" data-testid="period-preset-select">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {Object.entries(PRESETS).map(([k, label]) => (
          <SelectItem key={k} value={k} data-testid={`period-option-${k}`}>{label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
    {preset === 'custom' && (
      <>
        <Input type="date" value={range.from} max={range.to} onChange={(e) => onRange({ ...range, from: e.target.value })}
          className="w-[150px] border-[#E8E4DC] bg-white text-sm" data-testid="period-from-input" />
        <span className="text-xs text-[#9B9590]">to</span>
        <Input type="date" value={range.to} min={range.from} onChange={(e) => onRange({ ...range, to: e.target.value })}
          className="w-[150px] border-[#E8E4DC] bg-white text-sm" data-testid="period-to-input" />
      </>
    )}
  </div>
);
